// extracted by mini-css-extract-plugin
export default {"titleWrap":"VHQ8pz"};